import { render, staticRenderFns } from "./query-table.vue?vue&type=template&id=1f2c2f03&scoped=true"
import script from "./query-table.vue?vue&type=script&lang=js"
export * from "./query-table.vue?vue&type=script&lang=js"
import style0 from "./query-table.vue?vue&type=style&index=0&id=1f2c2f03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c2f03",
  null
  
)

export default component.exports